<template>
  <div>
    <div class="position-relative">
      <label for="search-input" class="search-icon">
        <i  class="far fa-search"></i>
      </label>
      <input
        id="search-input"
        type="text"
        class="form-control search-text ps-4"
        :placeholder="$t(placeholder)"
        :value="localValue"
        @input="onInput"
        ref="searchInput"
      />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';

export default {
  name: 'HMSearch',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'GENERAL.PLACEHOLDER.SEARCH',
    },
    delay: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      // local mirror so the input stays controlled by what the user typed and
      // is never reverted to a stale modelValue by an unrelated re-render that
      // lands inside the debounce window
      localValue: this.modelValue,
    };
  },
  watch: {
    modelValue(value) {
      // sync external/programmatic changes (e.g. clearing the search) without
      // clobbering in-progress typing
      if (value !== this.localValue) {
        this.localValue = value;
      }
    },
  },
  created() {
    this.emitValue = debounce(value => {
      this.$emit('update:modelValue', value);
    }, this.delay);
  },
  methods: {
    onInput($event) {
      this.localValue = $event.target.value;
      this.emitValue(this.localValue);
    },
  },
  mounted() {
    const input = this.$refs.searchInput;
    this.$emit('initialized', input);
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.search-icon {
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  color: var(--brand-color, $coral);
  margin-left: 0.5rem;
}
.search-text {
  &::placeholder {
    font-style: normal;
  }
}
</style>
